import axios from 'axios';
import {backendHost} from '../../config';

export const getPlayers = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/players`, {params});
};